import { IApplicationState } from '../../types/redux';
import { ENewAnswerModalStep } from '../../types/newAnswer';

export const getNewAnswerFormStep = (state: IApplicationState): ENewAnswerModalStep => {
  return state.newAnswer.meta.step;
};
